import { z } from 'zod';

export type QuickBooksSettingsDTO = z.infer<typeof quickBooksSettingsSchema>;
const zodString = z
  .string()
  .nullish()
  .transform((value) => value ?? '');

const zodBoolean = z.preprocess(
  (value) =>
    typeof value === 'string' || typeof value === 'number'
      ? /^(true|1)$/i.test(String(value))
      : value,
  z.boolean().nullable().default(false).catch(false),
);

export const quickBooksSettingsSchema = z.object({
  connected: zodBoolean,
  connected_at: zodString,
  invoice_item: zodString,
  qwc_url: zodString,
  password: zodString,
});
